import graphql__c7cc7cb090afa69acd28 from "./__generated__/PageSectionInformationSearch_pageSection.graphql.js";
import graphql__d6011a1115e97620e348 from "./__generated__/PageSectionInformationSearchQuery.graphql.js";import { useCallback, useState } from "react";
import { useFragment, graphql, fetchQuery } from "react-relay";
import { defineMessages } from "react-intl";

import appRelayEnvironment from "../../config/AppRelayEnvironment";
import PageSectionBlockWithTitleAndDescription from "./PageSectionBlockWithTitleAndDescription";
import Button from "../Buttons/Button";
import { useFormatMessage } from "../Intl/Context";
import Icon from "../Utils/Icon";

const PageSectionInformationSearch = props => {
  const pageSection = useFragment(
    PageSectionInformationSearch_pageSection,
    props.pageSection
  );
  const { id: sectionId, title, iconClass, description } = pageSection;

  const [isLoading, setIsLoading] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const handleSearchFieldUpdated = useCallback(e => setSearchValue(e.target.value), []);

  const handleSearchFormSubmitted = useCallback(
    async e => {
      e.preventDefault();
      setIsLoading(true);

      const results = await fetchResults(sectionId, searchValue, true);
      setSearchResults([results, ...searchResults]);

      setSearchValue("");
      setIsLoading(false);
    },
    [searchResults, searchValue, sectionId]
  );

  const t = useFormatMessage();
  const searchFieldPlaceholder = t(intlMessages.searchFieldPlaceholder);
  const sourcesTitle = t(intlMessages.sourcesTitle, { count: searchResults.length });

  return (
    <PageSectionBlockWithTitleAndDescription
      title={title}
      description={description}
      className="page-section-information-search"
      iconClassName={iconClass}
    >
      <form onSubmit={handleSearchFormSubmitted} className="d-flex align-items-center">
        <input
          name="search"
          className="flex-1 form-control"
          placeholder={searchFieldPlaceholder}
          onChange={handleSearchFieldUpdated}
          value={searchValue}
          disabled={isLoading}
          data-loading={isLoading}
        />

        <Button
          type="submit"
          className="btn btn-primary-inverse btn-sm border border-primary"
          iconClassName="icon-magnify"
          disabled={isLoading}
          data-loading={isLoading}
        />
      </form>

      <div className="search-results">
        {searchResults.map((result, index) => (
          <div key={index} className="search-result">
            <div className="search-result-question">{result.question}</div>

            <div
              className="search-result-answer"
              dangerouslySetInnerHTML={{ __html: result.answer }}
            />

            {result.sources.length > 0 && (
              <div className="search-result-sources">
                <h3 className="search-result-sources-title">{sourcesTitle}</h3>

                <ul className="search-result-sources-list">
                  {result.sources.map((source, index) => (
                    <li key={index}>
                      <a
                        href={source.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="search-result-source"
                      >
                        <Icon
                          className={`fa fa-${source.fileTypeIconClassName} search-result-source-icon`}
                        />

                        {source.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </PageSectionBlockWithTitleAndDescription>
  );
};

function fetchResults(sectionId, terms, displayOptionsByDefault = false) {
  return new Promise(resolve => {
    if (!terms && !displayOptionsByDefault) return resolve([]);

    const environment = appRelayEnvironment;
    const variables = { sectionId, terms: terms || "" };

    return fetchQuery(
      environment,
      PageSectionInformationSearchQuery,
      variables
    ).subscribe({
      next: data => resolve(data.informationSearch)
    });
  });
}

const PageSectionInformationSearch_pageSection = graphql__c7cc7cb090afa69acd28;

export default PageSectionInformationSearch;

const PageSectionInformationSearchQuery = graphql__d6011a1115e97620e348;

const intlMessages = defineMessages({
  searchFieldPlaceholder: {
    id: "pageSection.informationSearch.searchFieldPlaceholder",
    defaultMessage: "Écrivez votre question ici ..."
  },
  sourcesTitle: {
    id: "pageSection.informationSearch.sourcesTitle",
    defaultMessage: `{count, plural,
      one {Document source :}
      other {Documents source :}
    }`
  }
});
